























import { Component, Vue } from 'vue-property-decorator';
import AccountModalBase from '@/parts/account/AccountModalBase.vue';


export default Vue.extend({
  name: 'QuitModal',
  components: {
    AccountModalBase,
  },
});
